import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'react-apollo'
import withServiceDetail from '../../containers/with-service-detail'
import withModules from '../../containers/with-modules'
import ServiceFeature from '../../components/service-feature'
import ServicesFooter from '../../components/services-footer'
import { entryType } from '../../types'
import pagesHoc from '../pages-hoc'
import withCentreTradingHours from '../../containers/with-centre-trading-hours'
import { PromotionPositionContext } from '../../context'
import styles from './index.scss'

const EntryDetail = ({
  entry,
  template,
  modules: serviceModules,
  centre,
  centreTradingHours,
}) => {
  const className = styles.initialContentGroup
  return (
    <Fragment>
      <PromotionPositionContext.Provider
        value={template?.analyticsMetadata?.displayId}
      >
        <ServiceFeature
          centred
          position="left"
          topic={entry.category}
          title={entry.title}
          body={entry.body}
          centre={centre}
          centreTradingHours={centreTradingHours}
          analyticsMetadata={entry.analyticsMetadata}
        />
      </PromotionPositionContext.Provider>
      <ServicesFooter {...{ centre, className, serviceModules }} />
    </Fragment>
  )
}

EntryDetail.propTypes = {
  entry: entryType,
  template: PropTypes.shape({
    analyticsMetadata: PropTypes.shape({
      displayId: PropTypes.string,
    }),
  }),
  modules: PropTypes.array,
  centre: PropTypes.object,
  centreTradingHours: PropTypes.shape({
    tradingsHours: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        openingTime: PropTypes.string,
        closingTime: PropTypes.string,
        closed: PropTypes.bool,
        description: PropTypes.string,
        hourStatus: PropTypes.string,
      })
    ).isRequired,
    timeZone: PropTypes.string.isRequired,
    features: PropTypes.arrayOf(PropTypes.string),
  }),
}

EntryDetail.defaultProps = {
  modules: [],
}

const getMetaData = ({ centre, entry }) => ({
  title: `Westfield ${centre.title} | ${entry.title}`,
  description: `${entry.title} - ${entry.shortDescription.replace(
    /[ .]+$/g,
    ''
  )} at Westfield ${centre.title}`,
})

export const ServiceDetail = compose(
  withModules,
  withServiceDetail,
  withCentreTradingHours
)(pagesHoc(EntryDetail, getMetaData))
